import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import { Constants } from '../constants'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLoading: false,
        alertCode: 0,
        alertMessage: '',
    },
    mutations: {
        addAlert(state, {code, message}) {
            state.alertCode = code
            state.alertMessage = message
        },

        resetAlert(state) {
            state.alertCode = 0
            state.alertMessage = ''
        }
    },
    actions: {
        createAlert({commit}, {code, message}) {
            commit(Constants.STORE_MUTATION_ADD_ALERT, {code, message})
        },

        removeAlert({commit}) {
            commit(Constants.STORE_MUTATION_RESET_ALERT)
        }
    },
    getters: {
        isLoading: state => {
            return state.isLoading
        },

        alertCode: state => {
            return state.alertCode
        },

        alertMessage: state => {
            return state.alertMessage
        }
    },
    plugins: [
        createPersistedState()
    ],
    modules: {
    }
})
